import { logout, setNewTokens } from '@/store/reducers/Auth';
import { ensureFreshTokens } from './tokenRefresh';
import { baseQueryWithAuth } from './baseQueryWithAuth';
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';

const createBaseQueryWithReauth = (baseUrl: string) => {
  const baseQuery = baseQueryWithAuth(baseUrl);

  const baseQueryWithReauth: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
  > = async (args, api, extraOptions) => {
    const staleAccessToken = getAuthTokens(api)?.accessToken ?? null;
    const result = await baseQuery(args, api, extraOptions);

    if (!isAuthError(result)) return result;

    const outcome = await ensureFreshTokens({
      staleAccessToken,
      getStoreTokens: () => getAuthTokens(api),
      onNewTokens: (tokens) =>
        api.dispatch(setNewTokens({ ...tokens, userInfo: null })),
    });

    if (outcome === 'invalid') {
      api.dispatch(logout());
      return result;
    }

    if (outcome === 'unavailable') return result;

    return baseQuery(args, api, extraOptions);
  };

  return baseQueryWithReauth;
};

const isAuthError = (result: any) => result.error?.status === 401;

const getAuthTokens = (api: any) => (api.getState() as any)?.auth?.auth;

export default createBaseQueryWithReauth;
